import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.activate(this.tabTargets.findIndex(tab => tab.getAttribute("aria-selected") === "true"))
  }

  selectTab(event) {
    this.activate(this.tabTargets.indexOf(event.currentTarget))
  }

  keydown(event) {
    const current = this.tabTargets.indexOf(event.currentTarget)
    const last = this.tabTargets.length - 1
    const next = { ArrowRight: (current + 1) % this.tabTargets.length,
                   ArrowLeft: (current + last) % this.tabTargets.length,
                   Home: 0, End: last }[event.key]
    if (next === undefined) return

    event.preventDefault()
    this.activate(next)
    this.tabTargets[next].focus()
  }

  activate(index) {
    if (index < 0) return
    this.tabTargets.forEach((tab, position) => {
      tab.setAttribute("aria-selected", position === index ? "true" : "false")
      tab.tabIndex = position === index ? 0 : -1
      this.panelTargets[position].hidden = position !== index
    })
  }
}
